import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'dateFormat'
})
@Injectable({providedIn: 'root'})
export class DateFormatPipe implements PipeTransform {

  constructor(private readonly translateService: TranslateService) {
  }

  transform(value:any, showTime: boolean = false, hiddenDate: boolean = false): string {
    if (!value) return '';

    const date = new Date(value);

    if(Number.isNaN(date.getTime())){
      return '';
    }
    // Gün, ay ve yılı formatlamak için padLeft fonksiyonu kullanıyoruz
    const day = this.padLeft(date.getDate());
    const month = this.padLeft(date.getMonth() + 1); // getMonth() 0 tabanlıdır, bu yüzden 1 ekliyoruz
    const year = (date.getFullYear() % 100);

    // Get current language from TranslateService
    const currentLang = this.translateService.getDefaultLang();

    // Locale göre formatı ayarlıyoruz
    let formattedDate = '';
    if (currentLang === 'tr') {
      formattedDate = `${day}.${month}.${year}`; // format: DD-MM-YYYY
    } else {
      formattedDate = `${year}.${month}.${day}`; // Default format: YYYY-MM-DD
    }

    // Add time if showTime is true
    if (showTime) {
      const hours = this.padLeft(date.getHours());
      const minutes = this.padLeft(date.getMinutes());
      formattedDate += ` ${hours}:${minutes}`; // Append time
    }

    if (hiddenDate) {
      const hours = this.padLeft(date.getHours());
      const minutes = this.padLeft(date.getMinutes());
      formattedDate = ` ${hours}:${minutes}`;
    }

    return formattedDate;
  }

  // Helper function to add leading zeros if necessary
  padLeft(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }
}
